export class MixerCaptionLowerThirdDeleteCmd {}
